import React from 'react'
import { Container, Row } from 'reactstrap'
import TotalSales from './TotalSales'
import GrossSales from './GrossSales'
import OrderActivity from './OrderActivity'
import CoreCategories from './CoreCategories'
import TrendingProduct from './TrendingProduct'
import WeekendView from './WeekendView'
import NetIncome from './NetIncome'
import OpenInvoices from './OpenInvoices'

export default function EcommerceDashboardContainer() {
    return (
        <Container fluid className="dashboard-2">
            <Row>
                <TotalSales/>
                <GrossSales/>
                <OrderActivity/>
                <CoreCategories/>
                <TrendingProduct/>
                <WeekendView/>
                <NetIncome/>
                <OpenInvoices/>
            </Row>
        </Container>
    )
}
